<template>
    <v-card>
        <v-card-text>

            <!-- RECAPTCHA -->
            <title-card title="reCaptcha by Google" help="integrations-recaptcha">

                <v-container fluid class="pa-0">

                    <v-row dense>

                        <v-col cols="2">

                            <v-sheet color="white" max-width="100">
                                <img class="mr-5" :src="cdnBaseUrl('/img/recaptcha_logo.png')"/>
                            </v-sheet>

                            <v-switch class="mt-5"
                                      dense
                                      :disabled="!integrations.recaptcha.settings.client_key || !integrations.recaptcha.settings.server_key"
                                      v-model="integrations.recaptcha.enabled"
                                      label="Enabled"></v-switch>
                        </v-col>

                        <v-col cols="10">
                            <v-container fluid class="pa-0">

                                <v-row no-gutters>
                                    <v-col cols="12">

                                        <v-text-field v-model="integrations.recaptcha.settings.client_key"
                                                      placeholder="Enter site key"
                                                      hint="Site key"
                                                      persistent-hint
                                                      dense
                                                      :type="models.recaptcha.showClientKey ? 'text' : 'password'"
                                                      :append-icon="models.recaptcha.showClientKey ? 'mdi-eye' : 'mdi-eye-off'"
                                                      @click:append="models.recaptcha.showClientKey = !models.recaptcha.showClientKey"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-text-field v-model="integrations.recaptcha.settings.server_key"
                                                      placeholder="Enter secret key"
                                                      hint="Secret key"
                                                      persistent-hint
                                                      :type="models.recaptcha.showServerKey ? 'text' : 'password'"
                                                      :append-icon="models.recaptcha.showServerKey ? 'mdi-eye' : 'mdi-eye-off'"
                                                      @click:append="models.recaptcha.showServerKey = !models.recaptcha.showServerKey"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="6">
                                        <v-btn @click="saveCaptcha()" class="mt-4" color="primary">Save settings</v-btn>
                                    </v-col>

                                    <v-col cols="6" class="text-left">
                                        <v-btn text small class="mt-5" @click="goToVendorUrl('http://www.google.com/recaptcha/admin')">
                                            <v-icon class="mr-1">mdi-help-circle-outline</v-icon>
                                            reCaptcha Admin Dashboard
                                        </v-btn>
                                    </v-col>

                                </v-row>
                            </v-container>
                        </v-col>
                    </v-row>

                </v-container>
            </title-card>

            <!-- VONAGE DISABLED -->
            <title-card v-if="false" title="SMS by Vonage" help="integrations-vonage-sms" class="mt-3">

                <v-container fluid class="pa-0">

                    <v-row dense>

                        <v-col cols="2">

                            <v-sheet color="white" max-width="100">
                                <img class="mr-5" :src="cdnBaseUrl('/img/vonage.png')"/>
                            </v-sheet>

                            <v-switch class="mt-5"
                                      dense
                                      :disabled="!integrations.vonage.settings.api_key || !integrations.vonage.settings.api_secret"
                                      v-model="integrations.vonage.enabled"
                                      label="Enabled"></v-switch>
                        </v-col>

                        <v-col cols="10">
                            <v-container fluid class="pa-0">

                                <v-row no-gutters>
                                    <v-col cols="12">
                                        <v-text-field v-model="integrations.vonage.settings.api_key"
                                                      placeholder="Enter API key"
                                                      hint="API key"
                                                      persistent-hint
                                                      dense
                                                      clearable

                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-text-field v-model="integrations.vonage.settings.api_secret"
                                                      placeholder="Enter API secret"
                                                      hint="API secret"
                                                      persistent-hint
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="6">
                                        <v-btn @click="saveVonage()" class="mt-4" color="primary">Save settings</v-btn>
                                    </v-col>

                                    <v-col cols="6" class="text-left">
                                        <v-btn text small class="mt-5" @click="goToVendorUrl('https://dashboard.nexmo.com/')">
                                            <v-icon class="mr-1">mdi-help-circle-outline</v-icon>
                                            Vonage API Dashboard
                                        </v-btn>
                                    </v-col>

                                </v-row>
                            </v-container>
                        </v-col>
                    </v-row>

                </v-container>
            </title-card>

        </v-card-text>

    </v-card>

</template>

<script>

import TitleCard from "../../../components/UI/TitleCard";
import {mapActions} from 'vuex';
import Json from 'vue-json-pretty';

export default {
    name: "IntegrationsTab",

    components: {
        TitleCard,
        Json
    },

    data() {
        return {
            integrations: {
                recaptcha: {
                    name: 'recaptcha',
                    enabled: false,
                    settings: {
                        client_key: null,
                        server_key: null,
                    }
                },
                vonage: {
                    name: 'vonage',
                    enabled: false,
                    settings: {
                        api_key: null,
                        api_secret: null,
                    }
                }
            },

            models: {
                recaptcha: {
                    showClientKey: false,
                    showServerKey: false,
                },
                vonage: {
                    showApiKey: false,
                    showApiSecret: false,
                }
            }
        }
    },

    methods: {

        ...mapActions('PanelSettings', [
            'getIntegrations',
            'saveIntegrationSettings'
        ]),

        saveCaptcha() {
            this.saveSettings(this.integrations.recaptcha);
        },

        saveVonage() {
            this.saveSettings(this.integrations.vonage);
        },

        saveSettings(data) {
            this.saveIntegrationSettings(data)
                .then(() => {
                    Bus.$emit('flash-message', {message: 'Setting saved!'});
                })
                .catch((error) => {
                    Bus.$emit('flash-message', {type: 'error', message: 'OOPS! Settings failed to save. Try reloading!'});
                })
        },

        goToVendorUrl(url) {
            this.sendToUrl(url, true);
        }
    },

    mounted() {
        this.getIntegrations()
            .then((response) => {
                response.data.integrations.forEach(integration => {
                    this.integrations[integration.name] = integration;
                });

                if (!this.integrations.recaptcha.settings.client_key) {
                    this.models.recaptcha.showClientKey = true;
                }

                if (!this.integrations.recaptcha.settings.server_key) {
                    this.models.recaptcha.showServerKey = true;
                }

                if (!this.integrations.vonage.settings.api_key) {
                    this.models.vonage.showApiKey = true;
                }

                if (!this.integrations.vonage.settings.api_secret) {
                    this.models.vonage.showApiSecret = true;
                }
            })
            .catch((error) => {
                Bus.$emit('flash-message', 'OOPS! We failed to load integration. Try reloading!');
            })

    }
}

</script>
